
import { Vue, Component, Prop } from 'vue-property-decorator'
import CustomWrapper from '@/components/CustomWrapper.vue'

@Component({
  name: 'c-quizz-sentence',
  components: { CustomWrapper }
})
export default class CQuizzSentence extends Vue {

  @Prop({ default: 'div'}) tag!: string

}
